import { AgencyInfo } from '../../../redux/reducers/StoreSelectorReducer';
import { booleanMap, NodeInfo, StoreSelectModalState as StoreFilterEmployee } from '.';
import { getCompanyCfcDisplayName } from '../../../Common';

// キーワードによるフィルタリング時にノードを取得する
export function getFilteredNodeList(stores: AgencyInfo[], keyword: string, floorNum: number): NodeInfo[] {
  const keywords: string[] = keyword.split(' ').filter((v) => v);
  return getNodeList(stores, floorNum).filter((storeInfo) => isKeywordsMatch(storeInfo.name, keywords) && storeInfo.code !== '');
}

/**
 * isActiveを判定し、更新します
 * CodeSmell対応(重複処理のprivateFunction化)
 * @param node (mutable 可変 => 配列内のObjectのプロパティが変更されます)
 * @param index (immutable 不変 => readOnly)
 */
export const setIsActiveFromNodeInfo = (node: NodeInfo[], index: string) => {
  node.forEach((obj) => {
    if (obj.index === index) {
      obj.isActive = true;
    } else {
      obj.isActive = false;
    }
  });
};

// チェックボックス付きの列の表示を初期化する
export function initialization(stores: AgencyInfo[], newState: StoreFilterEmployee, index: string, floorNum: number) {
  // 店舗１
  if (floorNum < 2) {
    if (floorNum !== 1) {
      const areadept1List: NodeInfo[] = getNodeList(stores, 1);
      if (areadept1List.length && areadept1List.filter((obj) => obj.isActive).length === 0) {
        areadept1List[0].isActive = true;
      }
      newState.displayedOnAreaDept1List = areadept1List;

      index = areadept1List.filter((obj) => obj.isActive).length ? areadept1List.filter((obj) => obj.isActive)[0].index : '';
    } else {
      // codeSmell対応(重複処理の共通化)
      setIsActiveFromNodeInfo(newState.displayedOnAreaDept1List, index);
    }
  }

  // 店舗２
  if (floorNum < 3) {
    if (floorNum !== 2) {
      const areadept2List: NodeInfo[] = getNodeList(getNodeListByIndex(stores, index), 2);
      if (areadept2List.length && areadept2List.filter((obj) => obj.isActive).length === 0) {
        areadept2List[0].isActive = true;
      }
      newState.displayedOnAreaDept2List = areadept2List;

      index = areadept2List.filter((obj) => obj.isActive).length ? areadept2List.filter((obj) => obj.isActive)[0].index : '';
    } else {
      // codeSmell対応(重複処理の共通化)
      setIsActiveFromNodeInfo(newState.displayedOnAreaDept2List, index);
    }
  }

  // 店舗３
  if (floorNum < 4) {
    if (floorNum !== 3) {
      const areadept3List: NodeInfo[] = getNodeList(getNodeListByIndex(stores, index), 3);
      if (areadept3List.length && areadept3List.filter((obj) => obj.isActive).length === 0) {
        areadept3List[0].isActive = true;
      }
      newState.displayedOnAreaDept3List = areadept3List;

      index = areadept3List.filter((obj) => obj.isActive).length ? areadept3List.filter((obj) => obj.isActive)[0].index : '';
    } else {
      // codeSmell対応(重複処理の共通化)
      setIsActiveFromNodeInfo(newState.displayedOnAreaDept3List, index);
    }
  }

  // 店舗４
  if (floorNum < 5) {
    if (floorNum !== 4) {
      const areadept4List: NodeInfo[] = getNodeList(getNodeListByIndex(stores, index), 4);
      if (areadept4List.length && areadept4List.filter((obj) => obj.isActive).length === 0) {
        areadept4List[0].isActive = true;
      }
      newState.displayedOnAreaDept4List = areadept4List;

      index = areadept4List.filter((obj) => obj.isActive).length ? areadept4List.filter((obj) => obj.isActive)[0].index : '';
    } else {
      // codeSmell対応(重複処理の共通化)
      setIsActiveFromNodeInfo(newState.displayedOnAreaDept4List, index);
    }
  }

  // 店舗５
  if (floorNum < 6) {
    if (floorNum !== 5) {
      const areadept5List: NodeInfo[] = getNodeList(getNodeListByIndex(stores, index), 5);
      if (areadept5List.length && areadept5List.filter((obj) => obj.isActive).length === 0) {
        areadept5List[0].isActive = true;
      }
      newState.displayedOnAreaDept5List = areadept5List;

      index = areadept5List.filter((obj) => obj.isActive).length ? areadept5List.filter((obj) => obj.isActive)[0].index : '';
    } else {
      // codeSmell対応(重複処理の共通化)
      setIsActiveFromNodeInfo(newState.displayedOnAreaDept5List, index);
    }
  }

  newState.displayedOnAgencyList = getNodeList(getNodeListByIndex(stores, index), 6);
}

// チェックボックスの状態をノードに適用します
export function changeNode(stores: AgencyInfo[], newState: StoreFilterEmployee) {
  // 店舗１選択状態で初期化する
  newState.displayedOnAreaDept1List.forEach((nodeInfo) => {
    newState.isAreaDept1Checked[nodeInfo.index] = !nodeInfo.index.split(',').every((i) => newState.isStoreChecked[i] === false);
  });

  // 店舗２選択状態で初期化する
  newState.displayedOnAreaDept2List.forEach((nodeInfo) => {
    newState.isAreaDept2Checked[nodeInfo.index] = !nodeInfo.index.split(',').every((i) => newState.isStoreChecked[i] === false);
    // 店舗３選択状態で初期化する
    getNodeList(getNodeListByIndex(stores, nodeInfo.index), 3).forEach((nodeInfo) => {
      newState.isAreaDept3Checked[nodeInfo.index] = !nodeInfo.index.split(',').every((i) => newState.isStoreChecked[i] === false);
      // 店舗４選択状態で初期化する
      getNodeList(getNodeListByIndex(stores, nodeInfo.index), 4).forEach((nodeInfo) => {
        newState.isAreaDept4Checked[nodeInfo.index] = !nodeInfo.index.split(',').every((i) => newState.isStoreChecked[i] === false);
        // 店舗５選択状態で初期化する
        getNodeList(getNodeListByIndex(stores, nodeInfo.index), 5).forEach((nodeInfo) => {
          newState.isAreaDept5Checked[nodeInfo.index] = !nodeInfo.index.split(',').every((i) => newState.isStoreChecked[i] === false);
        });
      });
    });
  });

  //全て選択
}

// 親列のインデックスに従って店舗一覧を取得する
function getNodeListByIndex(stores: AgencyInfo[], index: string): AgencyInfo[] {
  const otherKeys = index.split(',');

  return stores.filter((storeInfo, i) => otherKeys.includes(i.toString()));
}

// 列で表示する一覧を取得する
function getNodeList(stores: AgencyInfo[], flg: number): NodeInfo[] {
  const nodeInfoList: NodeInfo[] = [];

  switch (flg) {
    case 1:
      stores.forEach((storeInfo: AgencyInfo, j, self) => {
        if (self.findIndex((obj) => obj.areaDeptCd01 === storeInfo.areaDeptCd01) === j) {
          nodeInfoList.push({
            index: storeInfo.index || '',
            code: storeInfo.areaDeptCd01 || '',
            name: storeInfo.areaDeptName01 || 'その他',
            isActive: false,
          });
        } else {
          nodeInfoList.filter(
            (areaDept) => (storeInfo.areaDeptCd01 === undefined && areaDept.code === '') || areaDept.code === storeInfo.areaDeptCd01
          )[0].index += ',' + storeInfo.index;
        }
      });
      break;
    case 2:
      stores.forEach((storeInfo: AgencyInfo, j, self) => {
        if (self.findIndex((obj) => obj.areaDeptCd02 === storeInfo.areaDeptCd02) === j) {
          nodeInfoList.push({
            index: storeInfo.index || '',
            code: storeInfo.areaDeptCd02 || '',
            name: storeInfo.areaDeptName02 || 'その他',
            isActive: false,
          });
        } else {
          nodeInfoList.filter(
            (areaDept) => (storeInfo.areaDeptCd02 === undefined && areaDept.code === '') || areaDept.code === storeInfo.areaDeptCd02
          )[0].index += ',' + storeInfo.index;
        }
      });
      break;
    case 3:
      stores.forEach((storeInfo: AgencyInfo, j, self) => {
        if (self.findIndex((obj) => obj.areaDeptCd03 === storeInfo.areaDeptCd03) === j) {
          nodeInfoList.push({
            index: storeInfo.index || '',
            code: storeInfo.areaDeptCd03 || '',
            name: storeInfo.areaDeptName03 || 'その他',
            isActive: false,
          });
        } else {
          nodeInfoList.filter(
            (areaDept) => (storeInfo.areaDeptCd03 === undefined && areaDept.code === '') || areaDept.code === storeInfo.areaDeptCd03
          )[0].index += ',' + storeInfo.index;
        }
      });
      break;
    case 4:
      stores.forEach((storeInfo: AgencyInfo, j, self) => {
        if (self.findIndex((obj) => obj.areaDeptCd04 === storeInfo.areaDeptCd04) === j) {
          nodeInfoList.push({
            index: storeInfo.index || '',
            code: storeInfo.areaDeptCd04 || '',
            name: storeInfo.areaDeptName04 || 'その他',
            isActive: false,
          });
        } else {
          nodeInfoList.filter(
            (areaDept) => (storeInfo.areaDeptCd04 === undefined && areaDept.code === '') || areaDept.code === storeInfo.areaDeptCd04
          )[0].index += ',' + storeInfo.index;
        }
      });
      break;
    case 5:
      stores.forEach((storeInfo: AgencyInfo, j, self) => {
        if (self.findIndex((obj) => obj.areaDeptCd05 === storeInfo.areaDeptCd05) === j) {
          nodeInfoList.push({
            index: storeInfo.index || '',
            code: storeInfo.areaDeptCd05 || '',
            name: storeInfo.areaDeptName05 || '',
            isActive: false,
          });
        } else {
          nodeInfoList.filter(
            (areaDept) => (storeInfo.areaDeptCd05 === undefined && areaDept.code === '') || areaDept.code === storeInfo.areaDeptCd05
          )[0].index += ',' + storeInfo.index;
        }
      });
      break;
    case 6:
      stores.forEach((storeInfo: AgencyInfo) => {
        nodeInfoList.push({
          index: storeInfo.index || '',
          code: storeInfo.agencyCd || '',
          // (企業名正式名称)取次店正式名称 の形式にて、値を表示します
          name: getCompanyCfcDisplayName(String(storeInfo.companyCfc), storeInfo.longName),
          isActive: false,
        });
      });
      return nodeInfoList;
    default:
      throw new Error('9999');
  }

  return nodeInfoList.sort((a, b) => a.name.localeCompare(b.name, 'ja'));
}

export function isKeywordsMatch(src: string, keywords: string[]): boolean {
  let result = true;
  keywords.forEach((keyword) => {
    if (src.indexOf(keyword) < 0) {
      result = false;
    }
  });
  return result;
}

export function formatTargetStores(stores: AgencyInfo[], isStoreChecked: booleanMap): string[] {
  return stores.filter((store, index) => isStoreChecked[index]).map((storeInfo) => storeInfo.agencyCd);
}

export function checkDisplayDetermind(index: string, isStoreChecked: booleanMap): boolean {
  const allIsTrue = index.split(',').every((i) => isStoreChecked[i] === true);

  if (allIsTrue) {
    return false;
  }
  return true;
}
